
























































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { GripEnabler } from '../../../store/types/grip.types';
import BasePagination from '../../../components/base/BasePagination.vue';
import { PaginationMixin } from '../../../components/base/pagination.mixin';
import { mixins } from 'vue-class-component';
import { getUpperCase } from '../../../utils/general.util';

@Component({
  components: { BasePagination },
})
export default class EnablerList extends mixins(PaginationMixin) {
  @Prop() public items!: GripEnabler[];
  @Prop(Number) public totalNumberOfPage!: number;
  @Prop(Number) public totalCount!: number;
  @Prop(Boolean) public isFirstPage!: boolean;
  @Prop(Boolean) public isLastPage!: boolean;
  @Prop(Number) public startItemIndex!: number;
  @Prop(Number) public endItemIndex!: number;

  // Receive the ID of the enabler being edited from the parent component
  @Prop({ default: null }) public editingEnablerId!: number | null;

  // Receive the minimized state from the parent
  @Prop({ type: Boolean, default: false }) public isMinimized!: boolean;

  get projectId(): number {
    return +this.$route.params.projectId;
  }

  public getUpperCase(value: string) {
    return getUpperCase(value);
  }

  /**
   * Emits an event to the parent component to handle editing.
   * @param {GripEnabler} enabler - The enabler data to be edited.
   */
  public handleEdit(enabler: GripEnabler): void {
    this.$emit('edit-enabler', enabler);
  }
}
